export const CardIcons = Object.freeze({
    visa: 'fab fa-cc-visa',
    mastercard: 'fab  fa-cc-mastercard',
    jcb: 'fab  fa-cc-jcb',
    amex: 'fab  fa-cc-amex',
    discover: 'fab fa-cc-discover',
    diners: 'fab fa-cc-diners-club',
    unknown: 'fas fa-credit-card',
});
